import Common from "./Common";
import Output from "./Output";
import Input from "../Utils/Input";

export default class FluidCursor {
    constructor(){
        this.common = new Common();
        this.input = Input.getInstance();

        this.init();
    }

    init(){
        this.output = new Output();
    }

    resize(){
        this.common.resize();
        this.output.resize();
    }

    update(){
        this.input.update();
        this.common.update();
        this.output.update();
    }

    getTexture() {
        return this.common.getTexture();
    }

    destroy(){
        this.common.destroy();
        this.output.destroy();
    }
}
